<template>
    <section class="st-main-contents">
        <h2 class="blind">본문</h2>

        <MainBranch />

        <article class="main-banner">
            <!-- 메인 배너 > 링크 이동 -->
            <!-- 배너 목록 -->
            <div v-for="(item, index) in bannerList" :key="index" class="banner-box">
                <!-- 공지사항인경우 페이지이동, 신규팝업 -->
                <a
                    v-if="item.bannerType === 'NOTICE' && item.bannerUrlDispArea === 'G' && item.bannerUrlNDispArea !== '1'"
                    href="javascript:;"
                    class="banner-img"
                    title="페이지이동"
                    @click.prevent="doShowDetail(`/notice/detail/${item.typeId}`)"
                >
                    <!-- 페이지이동 " -->
                    <img :src="item.bannerFileUrl" :alt="item.bannerTitle" />
                </a>
                <a
                    v-else-if="item.bannerType === 'NOTICE' && item.bannerUrlDispArea === 'G' && item.bannerUrlNDispArea === '1'"
                    href="javascript:;"
                    class="banner-img"
                    title="새창"
                    @click.prevent="showPopup(item.bannerUrl)"
                >
                    <!-- 새창 " -->
                    <img :src="item.bannerFileUrl" :alt="item.bannerTitle" />
                </a>

                <!-- 이벤트인경우 페이지이동, 신규팝업 -->
                <a
                    v-else-if="item.bannerType === 'EVENT' && item.bannerUrlDispArea === 'G' && item.bannerUrlNDispArea !== '1'"
                    href="javascript:;"
                    class="banner-img"
                    title="페이지이동"
                    @click.prevent="doShowDetail(`/event/detail/${item.typeId}`)"
                >
                    <!-- 페이지이동  -->
                    <img :src="item.bannerFileUrl" :alt="item.bannerTitle" />
                </a>
                <a
                    v-else-if="item.bannerType === 'EVENT' && item.bannerUrlDispArea === 'G' && item.bannerUrlNDispArea === '1'"
                    href="javascript:;"
                    class="banner-img"
                    title="새창"
                    @click.prevent="showPopup(item.bannerUrl)"
                >
                    <!-- 새창 " -->
                    <img :src="item.bannerFileUrl" :alt="item.bannerTitle" />
                </a>

                <!-- Web인경우 페이지이동, 신규팝업 -->
                <a
                    v-else-if="item.bannerType === 'URL' && item.bannerUrlDispArea === 'G' && item.bannerUrlNDispArea !== '1'"
                    href="javascript:;"
                    class="banner-img"
                    title="페이지이동"
                    @click="doShowDetail(item.bannerUrl)"
                >
                    <!-- 페이지이동 " -->
                    <img :src="item.bannerFileUrl" :alt="item.bannerTitle" />
                </a>
                <a
                    v-else-if="item.bannerType === 'URL' && item.bannerUrlDispArea === 'G' && item.bannerUrlNDispArea === '1'"
                    href="javascript:;"
                    class="banner-img"
                    title="새창"
                    @click.prevent="showPopup(item.bannerUrl)"
                >
                    <!-- 새창 " -->
                    <img :src="item.bannerFileUrl" :alt="item.bannerTitle" />
                </a>

                <!-- 공지, 이벤트, Web인경우 Modal -->
                <a
                    v-else-if="item.bannerUrlDispArea === 'P'"
                    href="javascript:;"
                    class="banner-img"
                    title="팝업"
                    @click="doShowModal(item.bannerUrl)"
                >
                    <!-- 내부 Modal창  -->
                    <img :src="item.bannerFileUrl" :alt="item.bannerTitle" />
                </a>

                <div class="banner-info">
                    <h3 class="tit">{{ item.bannerTitle }}</h3>
                    <p class="summary">{{ item.bannerConts }}</p>
                    <div class="details">
                        <span class="period">{{ item.bannerSchedule }}</span>
                    </div>
                </div>
            </div>

            <!-- 지도 배너-->
            <div class="banner-box">
                <!-- doShowMap -->
                <a
                    href="javascript:;"
                    @click="doShowModal('map')"
                    class="banner-img"
                    data-popup-target="#popup-map"
                    aria-label="스타필드 마켓 지도보기"
                    ><img src="@/assets/images/main/banner_map.jpg" alt="배너 이미지"
                /></a>
                <div class="banner-info">
                    <h3 class="tit">{{ storeName }} 둘러보기</h3>
                    <p class="summary">원하는 매장과 시설을 쉽게 찾아보세요.</p>
                </div>
            </div>
        </article>

        <!-- 점포 선택 -->
        <MainStore />
    </section>

    <!-- // 공지상세 모달 LayerPop -->
    <NoticeDetailView ref="modalNotice" v-show="modalNoticeVisible" @close="modalNoticeOpenClose(false)" />

    <!-- // 이벤트상세 모달 LayerPop -->
    <EventDetailView ref="modalEvent" v-show="modalEventVisible" @close="modalEventOpenClose(false)" />

    <!-- // 웹페이지상세 모달 LayerPop -->
    <WebDetailView ref="modalWeb" v-show="modalWebVisible" @close="modalWebOpenClose(false)" />

    <!-- // Map상세모달 LayerPop -->
    <MapView ref="modalMap" v-if="modalMapVisible" @close="modalMapOpenClose(false)" />
</template>

<script setup>
    defineOptions({
        name: 'HomeView',
    });

    import { onMounted, ref, toRefs, watch } from 'vue';
    import { useRootStore } from '@/stores/modules';
    import MapView from '@/views/MapView.vue';
    import WebDetailView from '@/views/web/WebDetailView.vue';
    import EventDetailView from '@/views/event/EventDetailView.vue';
    import NoticeDetailView from '@/views/notice/NoticeDetailView.vue';
    import { MainStore, MainBranch } from '@/components/home';

    const rootStore = useRootStore();
    const { getStarFieldInfo, getBranchList, syncBranchFromUrl } = rootStore;
    const { storeName, selectedBranchId } = toRefs(rootStore);

    const modalNoticeVisible = ref(false);
    const modalEventVisible = ref(false);
    const modalWebVisible = ref(false);
    const modalMapVisible = ref(false);
    const bannerList = ref([]);
    const modalNotice = ref(null);
    const modalEvent = ref(null);
    const modalWeb = ref(null);
    const modalMap = ref(null);

    const isIOS = /iP(ad|hone|od)/i.test(navigator.userAgent);

    // 배너목록 조회
    const getBannerList = async () => {
        const res = await getStarFieldInfo(`/banner/list?branchId=${selectedBranchId.value}`);
        if (res.status === 200) {
            bannerList.value = res.data.bannerList;
        } else {
            bannerList.value = [];
        }
    };
    // 공지상세모달창 열기/닫기
    const modalNoticeOpenClose = (modalVisible) => {
        modalNoticeVisible.value = modalVisible;
    };
    // 이벤트상세모달창 열기/닫기
    const modalEventOpenClose = (modalVisible) => {
        modalEventVisible.value = modalVisible;
    };
    // 웹상세모달창 열기/닫기
    const modalWebOpenClose = (modalVisible) => {
        modalWebVisible.value = modalVisible;
    };
    // 맵모달창 열기/닫기
    const modalMapOpenClose = (modalVisible) => {
        modalMapVisible.value = modalVisible;
    };
    // 모달창 호출
    const doShowModal = (linkUrl) => {
        // 모달인 경우 Body Scroll 표시안함
        document.body.classList.add('no-scroll');

        // 공지사항 상세 호출시
        if (linkUrl.indexOf('notice') > -1) {
            modalNoticeOpenClose(true);
            const noticeId = linkUrl.substring(linkUrl.lastIndexOf('/') + 1);
            modalNotice.value?.getNoticeDetail(noticeId, 'MODAL');

            // 이벤트 상세 호출시
        } else if (linkUrl.indexOf('event') > -1) {
            modalEventOpenClose(true);
            const eventId = linkUrl.substring(linkUrl.lastIndexOf('/') + 1);
            modalEvent.value?.getEventDetail(eventId, 'MODAL');

            // 맵화면 호출시
        } else if (linkUrl.indexOf('map') > -1) {
            modalMapOpenClose(true);
            modalMap.value?.setMapEnv();

            // 일반 URL페이지를 호출하는 경우
        } else {
            modalWebOpenClose(true);
            modalWeb.value?.getWebDetail(linkUrl, 'MODAL');
        }
    };
    // 공지, 이벤트 상세(페이지이동)
    const doShowDetail = (url) => {
        localStorage.setItem('gotoPage', 'Y');

        // 현재 URL에서 실제 쿼리 파라미터 가져오기
        const currentParams = new URLSearchParams(window.location.search);

        // 대상 URL이 이미 쿼리 파라미터를 가지고 있는지 확인
        const hasQuery = url.includes('?');
        const currentQuery = currentParams.toString();

        if (currentQuery) {
            url = hasQuery ? `${url}&${currentQuery}` : `${url}?${currentQuery}`;
        }

        location.href = url;
    };
    const closePopComp = (e) => {
        e.preventDefault();
        e.stopPropagation();
        window.removeEventListener('popstate', bindPopComp);
    };
    function bindPopComp(e) {
        // 페이지 이동시
        const isGotoPage = localStorage.getItem('gotoPage');
        if (isGotoPage === 'Y') {
            closePopComp(e);

            // 페이지 이동 Flag 초기화
            localStorage.setItem('gotoPage', null);
        }
    }
    const getData = async () => {
        // 점포 목록 조회
        await getBranchList();
        // 배너목록
        getBannerList();
    };
    const showPopup = (bannerUrl) => {
        let to = ''; // Router호출명(신규팝업) winAbout, winMap, winNotice ...
        let sendData = {};

        // 현재 URL에서 실제 쿼리 파라미터 가져오기
        const currentParams = new URLSearchParams(window.location.search);
        const currentQuery = {};
        currentParams.forEach((value, key) => {
            currentQuery[key] = value;
        });

        // 공지사항 상세 호출시
        if (bannerUrl.indexOf('notice') > -1) {
            to = 'Notice';
            sendData = { noticeId: bannerUrl.substring(bannerUrl.lastIndexOf('/') + 1) };

            // 이벤트 상세 호출시
        } else if (bannerUrl.indexOf('event') > -1) {
            to = 'Event';
            sendData = { eventId: bannerUrl.substring(bannerUrl.lastIndexOf('/') + 1) };

            // 맵 호출시
        } else if (bannerUrl.indexOf('map') > -1) {
            to = 'Map';
            sendData = { branchId: selectedBranchId.value };

            // 일반 Web페이지인 경우
        } else {
            to = 'Web';
            sendData = { linkUrl: bannerUrl };
        }

        if (to === 'Web') {
            // 외부 URL인 경우 쿼리 파라미터 추가
            const hasQuery = bannerUrl.includes('?');
            if (Object.keys(currentQuery).length > 0) {
                const queryString = new URLSearchParams(currentQuery).toString();
                bannerUrl = hasQuery ? `${bannerUrl}&${queryString}` : `${bannerUrl}?${queryString}`;
            }
            window.open(bannerUrl, '_blank');
        } else {
            localStorage.setItem('sendData', JSON.stringify(sendData));
            const url = '/win' + to;

            // 현재 쿼리 파라미터를 URL에 추가하고 branch 파라미터 유지
            const queryParams = {
                ...currentQuery,
                branch: selectedBranchId.value,
            };
            const queryString = new URLSearchParams(queryParams).toString();
            const finalUrl = queryString ? `${url}?${queryString}` : url;

            if (isIOS) {
                location.href = finalUrl;
            } else {
                window.open(finalUrl, '_blank');
            }
        }
    };

    watch(selectedBranchId, (to, from) => {
        if (to && from) {
            getBannerList();
        }
    });
    onMounted(() => {
        history.scrollRestoration = 'auto';

        // URL과 selectedBranchId 동기화
        syncBranchFromUrl();

        // 데이터 조회
        getData();

        // 브라우저 뒤로가기 버튼 막기
        window.addEventListener('popstate', bindPopComp);
    });
</script>
